<div class="page">
  <div class="page__container">


    <ng-container>
      <ng-template #modalTransferCreditsType0 let-c="close" let-d="dismiss">
        <wsb-transfer-credits-modal
          (primary)="closeModal()"
          cancelButtonEnable="true"
          [subaccount]="subaccountModal"
          (dismiss)="d()"
          title="{{ 'sender_new' | translate }}"
          [user]="user"
          [transferType]="transferType"
        >
        </wsb-transfer-credits-modal>
      </ng-template>
    </ng-container>

    <ng-container>
      <ng-template #modalTransferCreditsType2 let-c="close" let-d="dismiss">
        <wsb-transfer-credits-modal
          (primary)="closeModal()"
          cancelButtonEnable="true"
          [subaccount]="subaccountModal"
          (dismiss)="d()"
          title="{{ 'sender_new' | translate }}"
          [transferType]="transferType"
        >
        </wsb-transfer-credits-modal>
      </ng-template>
    </ng-container>


    <h1 class="page__title h2 mb-5">{{ 'settings_title_subaccounts' | translate }}</h1>
    <wsb-atlas-button class="my-3" [label]="'settings_subaccounts_create_title'" routerLink="/reseller/subaccounts-create">{{
      'contact_list_new' | translate
    }}</wsb-atlas-button>
    <div class="my-5">

        <ng-template #modalConfirmImpersonate let-c="close" let-d="dismiss">
          <wsb-modal
            (primary)="modalImpersonate()"
            (dismiss)="d()"
            cancelButtonEnable="true"
            title="{{ 'settings_subaccounts_impersonate_title' | translate }}"
            text="{{ 'settings_subaccounts_impersonate_confirm' | translate }}"
          ></wsb-modal>
        </ng-template>

      <wsb-atlas-grid
        #grid
        *ngIf="tableColumnDefs && tableGridOptions"
        class="atlas-grid-simplest"
        class="mt-2"
        [loading]="tableLoading"
        [columnDefs]="tableColumnDefs"
        [options]="tableGridOptions"
        [@gridIsLoaded]="gridAnimationState"
        [components]="components"
        [checkboxDisable]="true"
      >
      </wsb-atlas-grid>
    </div>
  </div>
</div>
